import { FacetBase } from "../models/facet-base/facet-base";

export const getFacetFromFieldName = (
	fieldName: string,
	facets: any,
): FacetBase => {
	for (let index = 0; index < Object.keys(facets).length; index++) {
		const facet = facets[index] as any;

		if (facet.fieldName.toLowerCase() === fieldName.toLowerCase()) {
			return facet;
		}
	}

	return null;
};
